import React from 'react';
import { find, map } from 'lodash';
import CSVToArray from '../../helpers/CSVToArray';
import ReactSelect from './ReactSelect';
import Spinner  from './Spinner';
import Tooltip from './Tooltip';

class CSVImport extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            keys: [],
            data: [],
            keyMap: {},
            showForm: false
        }
    }
    
    readCSV = (event, key) => {
        const { fields } = this.props;
        const fieldKeys = map(fields, 'key');
        let reader = new FileReader();
        const currentFile = event.target.files[0];
        reader.onload = (file) => {
            const data = CSVToArray(file.target.result);
        
            if (data && data.length) {
                const keys = Object.keys(data[0]);
                let keyMap = {};
        
                for (let key of keys) {
                    if (fieldKeys.includes(key)) {
                        keyMap[key] = key;
                    }
                }
        
                // Pre-select first option for fields with an options array
                for (let field of fields) {
                    if (field.options && field.options.length && field.selectFirst) {
                        keyMap[field.key] = field.options[0].value;
                    }
                }
        
                this.setState({ data, keys, keyMap, showForm: true });
            }
        }
        reader.readAsText(currentFile);
    }
    
    setField = (field, option) => {
        let { keys, keyMap } = this.state;
        const existing = keyMap[field];
        if(existing) {
            keys.push(existing);
        }
        keyMap[field] = option.value;
        this.setState({
            keyMap,
            keys: keys.filter(key=>key!=option.value)
        })
    }
    
    setFreeText = (fieldKey, value) => {
        this.setState(({ keyMap }) => ({
            keyMap: { ...keyMap, [fieldKey]: value }
        }));
    }
    
    renderSubmitButton = (loading) => {
        const { fields } = this.props;
        const { keyMap } = this.state;
        for(let field of fields) {
            if(field.required && !keyMap[field.key])
                return null;
        }
        return <span>
            <button className="default-btn default-btn--small" onClick={this.submit}>Import</button>
            <Spinner enabled={loading} className="spinner spinner-inline" />
        </span>
    }
    
    submit = () => {
        const { data, keyMap } = this.state, 
            { onSubmit, fields } = this.props;
        
        const result = data.map(row => {
            let formattedRow = {}
            
            //for(let key of Object.keys(keyMap)) {
            //    formattedRow[key] = row[keyMap[key]];
            //}
            
            for( let field of fields ) {
                const { key, options, freeText } = field;
                if(options !== undefined || freeText) {
                    formattedRow[key] = keyMap[key];
                }
                else {
                    formattedRow[key] = row[keyMap[key]];
                }
            }
            return formattedRow;
        });
        return onSubmit(result);
    }
        
    render() {
        const { fields, loading = false, formHeader = '' } = this.props;
        const { keys, keyMap, showForm } = this.state;
        let options = keys.map(key=>({value: key, label: key}));
        options.unshift({label: '-not set-', value: null});
        return (
            <div>
                <input type="file" id="csvFile" accept="text/csv" onChange={this.readCSV} />
                {showForm && <div className="entity-filter-form">
                {formHeader && <h4>{formHeader}</h4>}
                {fields.map(field => {
                    const isFreeText = !!field.freeText;
                    const value = keyMap[field.key] || null;
                    const fieldOptions = field.options
                        ? [{ label: '-not set-', value: null }, ...field.options]
                        : options;
                    const selectedValue = !isFreeText
                        ? find(fieldOptions, option => option.value == value)
                        : undefined;
                
                    return (
                        <div className="csv-item" key={field.key}>
                            <div className="csv-item-label">
                                <span>{field.label} {field.required ? '*' : ''}</span>
                                {field.tooltip && (
                                    <div className="table-header-tooltip">
                                        <Tooltip position="bottom-center" message={field.tooltip} tooltipClass="toolbar-title-tooltip" />
                                    </div>
                                )}
                            </div>
                            {isFreeText
                                ? <input
                                    type="text"
                                    className="default-input"         // use whatever your input class is
                                    value={keyMap[field.key] || ''}
                                    onChange={e => this.setFreeText(field.key, e.target.value)}
                                    placeholder={field.placeholder || ''}
                                  />
                                : <ReactSelect
                                    options={fieldOptions}
                                    value={selectedValue}
                                    onChange={option => this.setField(field.key, option)}
                                  />
                            }
                        </div>
                    );
                })}
                </div>}
                {this.renderSubmitButton(loading)} 
            </div>            
        )
    }
}

export default CSVImport